module.exports = __webpack_public_path__ + "ce1aec1c7983304f6ab454d16731f986.svg";